module.exports = __webpack_public_path__ + "img/sword-nemesis.0218d5ca.jpg";